import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { EOtpremniceClient, TipAkcizneKategorije } from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-tip-akcizne-kategorije-dropdown',
  templateUrl: './tip-akcizne-kategorije-dropdown.component.html',
  styleUrls: ['./tip-akcizne-kategorije-dropdown.component.scss']
})
export class TipAkcizneKategorijeDropdownComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();

  /** Props */
  items: SelectItem[] = [];

  /** I/O */
  @Input() formCtrl: AbstractControl;
  @Input() formCtrlId: string;
  @Input() parentCtrl: any = 'body';
  @Output() onItemChange = new EventEmitter<TipAkcizneKategorije>();

  constructor(
    private _client : EOtpremniceClient,
  ) { }

  ngOnInit(): void {
    this._load();
  }

  private async _load() {
    this._subs.add(
      this._client.getTipAkcizneKategorije().subscribe((res) => {
        this.items = res.data!.tipAkcizneKategorijeList!.map((x) => ({
          value: x.tip,
          label: x.tipStr,
          title: x.opis,
        }));
        this.items.unshift({ value: null, label: '--' });
      })
    );
  }

  handleOnItemChange(event: any) {
    if (this.formCtrl) {
      this.formCtrl.setValue(event?.value ?? event);
    }
    this.onItemChange.emit(event);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
